import { reactive } from "vue";

import { useI18n } from 'vue-i18n';
import { t } from '@/utils/i18n'
interface NowSelect {
  id?: number | null;
  name?: string;
  code?: string;
  thumb?: boolean;
  thumbCount?: number;
  collect?: boolean;
  collectCount?: number
}
export interface checkState {
  showVoice: boolean;
  user: any;
  chatData: any;
  userList: any;
  isPhone: boolean;
  nowSelect: NowSelect;
  token: string;
  balance?: number | null;
  weixin?: boolean
  searchTime?: number
  searchTimeInput?: string
  scoreTime?: number
  allModel?: any
  allPluginUser?: any
  workflowPlugin?: any
  weixinDesktop?: boolean
  selectchannel?: any
  selectReadType?: any
  customerList?: any
  sessionId?: string
  channelid?: string
  sessionIdchannelid?: string
  selectSessionIndex?: any
  earliestTimeDetail?: any
  privilege?: any
  clientId?: any
  routerList?: any
  userPrivige?: any
  inviteParam?: string
  headImageUrl?: string
  chatName?: string
  readType?: string
  chatUserDetail?: any
  isShowKuCode?: boolean
  flowElement?: any
  flowLine?: any
  flowData?: any
  draw?: boolean
  drawType: string | ''
  drawForm: any
  drawFormId: string
  flowAppCode: string
  runLoading: boolean
  runForm: object
  clickEdgeId: string
  clickActiveId: string
  flowName: string
  addLines: any
  applyList: any
  noticeNameList: any
  runNodeSatusList: any
  runEdgeSatusList: any
  isOpenAddNewbase: boolean
  numA: number
  phoneData: any
  customerData: any
  chatO: any
  nowSelectPlugin: any
  nowSelectModel: any
  homeMenuList: any
  clickChat: number
  openFlowHis: number
  flowForm: any
  activeFlow: boolean
  questionFlow: any
  saveTime: number
  saveAction: boolean
}
export const State: checkState = {
  user: {},
  chatData: [],
  userList: [],
  isPhone: false,
  customerData: '',
  showVoice: false,
  nowSelect: {
    id: null,
    name: "",
    code: "",
    thumb: false,
    thumbCount: 0,
    collect: false,
    collectCount: 0
  },
  token: "",
  balance: null,
  weixin: false,
  searchTime: 0,
  searchTimeInput: '',
  scoreTime: 0,
  allModel: [],
  allPluginUser: [],
  workflowPlugin: [],
  weixinDesktop: false,
  selectchannel: '',
  selectReadType: '',
  customerList: [],
  sessionId: '',
  channelid: '',
  sessionIdchannelid: '',
  selectSessionIndex: 0,
  earliestTimeDetail: '',
  privilege: '',
  clientId: '',
  homeMenuList: [
    { name: t('home'), routerName: 'app' },
    { name: t('chat'), routerName: 'home' },
    // { name: t('paint'), routerName: 'paintPic' },
    { name: t('template'), routerName: 'template' }
  ],
  routerList: [
    {
      name: t('Create'),
      id: '1',
      menu: [
        {
          name: t('Apps'),
          routerName: 'myApp',
          isAvailable: true,
          hiddenMenu: false,
          id: '1-1',
          path: '/console/agents',
        },
        {
          name: t('Knowledge'),
          routerName: 'knowledgeBase',
          isAvailable: true,
          hiddenMenu: false,
          id: '1-2',
          path: '/console/knowledge',
        },
        {
          name: t('Database'),
          routerName: 'database',
          isAvailable: true,
          hiddenMenu: false,
          id: '1-3',
          path: '/console/database',
        },
        {
          name: t('Plugins'),
          routerName: 'plugins',
          isAvailable: true,
          hiddenMenu: false,
          id: '1-4',
          path: '/console/plugins',
        },
        {
          name: t('Workflow'),
          routerName: 'flow',
          isAvailable: true,
          hiddenMenu: false,
          id: '1-5',
          path: '/console/workflows',
        },
      ],
    },
    {
      name: t('Access'),
      id: '2',
      menu: [
        {
          name: t('APIAccess'),
          routerName: 'openInterface',
          isAvailable: true,
          hiddenMenu: false,
          id: '2-1',
          path: '/console/Integrations',
        },
        {
          name: t('Client'),
          routerName: 'clients',
          isAvailable: false,
          hiddenMenu: false,
          content: t('Standard'),
          id: '2-2',
          path: '/console/clients',
        },
        {
          name: t('Customers'),
          routerName: 'customManage',
          isAvailable: true,
          hiddenMenu: true,
          id: '2-3',
          path: '/console/customManage',
        },
        {
          name: t('Chat'),
          routerName: 'chatManage',
          isAvailable: false,
          hiddenMenu: false,
          content: t('Pro'),
          id: '2-4',
          path: '/console/chatManage',
        },
      ],
    },
    {
      name: t('Manage'),
      id: '3',
      menu: [
        {
          name: t('Account'),
          routerName: 'myCenter',
          isAvailable: true,
          hiddenMenu: false,
          id: '3-1',
          path: '/console/account',
        },
        {
          name: t('Dashboard'),
          routerName: 'dataAnalysis',
          isAvailable: true,
          hiddenMenu: false,
          content: t('Standard'),
          id: '3-2',
          path: '/console/analysis',
        },
        {
          name: t('Team'),
          routerName: 'teamSpace',
          isAvailable: false,
          hiddenMenu: false,
          content: t('Pro'),
          id: '3-3',
          path: '/console/teamSpace',
        },
      ],
    },
    {
      name: t('Discover'),
      id: '4',
      menu: [
        {
          name: t('Templates'),
          routerName: 'templateCenter',
          isAvailable: true,
          hiddenMenu: false,
          id: '4-1',
          path: '/console/templates',
        },
        {
          name: t('Store'),
          routerName: 'home',
          isAvailable: true,
          hiddenMenu: false,
          id: '4-2',
          path: '/home',
        },
      ],
    },
  ],
  userPrivige: '',
  inviteParam: '',
  headImageUrl: '',
  chatName: '',
  readType: '',
  chatUserDetail: '',
  isShowKuCode: false,
  flowElement: [],
  flowLine: [],
  flowData: [],
  draw: false,
  drawType: '',
  drawForm: '',
  flowAppCode: '',
  runLoading: false,
  runForm: {},
  drawFormId: '',
  clickEdgeId: '',
  clickActiveId: '',
  flowName: '',
  addLines: {
    source: '',
    sourceHandle: ''
  },
  applyList: '',
  noticeNameList: [],
  runNodeSatusList: [],
  runEdgeSatusList: [],
  isOpenAddNewbase: false,
  numA: 0,
  phoneData: '',
  chatO: '',
  nowSelectPlugin: [],
  nowSelectModel: 'gpt-4.1-mini',
  clickChat: 0,
  openFlowHis: 0,
  flowForm: "",
  activeFlow: false,
  questionFlow: [],
  saveTime: 0,
  saveAction: false
};
export function createState() {
  return reactive(State);
}
